import { useCreateSpaceGroupMutation } from "@circle-react/components/SpaceGroups/NewFormV2/hooks/useCreateSpaceGroupMutation";
import { NewSpaceGroupFormV3 } from "@circle-react/components/SpaceGroups/NewFormV3";
import { Modal } from "@circleco/compass/components/Modal";

import { t } from "@/i18n-js/instance";

import type { NewSpaceGroupModalProps } from "./types";

const formId = "new-space-group-form";

interface NewSpaceGroupModalComponentProps extends NewSpaceGroupModalProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const NewSpaceGroupModalComponent = ({
  open,
  onOpenChange,
  position,
  prefillData,
}: NewSpaceGroupModalComponentProps) => {
  const { mutate: createSpaceGroupMutation, isPending: isSubmitting } =
    useCreateSpaceGroupMutation({
      position,
      onSuccess: () => onOpenChange(false),
    });

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="lg">
      <Modal.Content>
        <Modal.Header title={t("space_groups.form.create.title")} />
        <Modal.Body>
          <NewSpaceGroupFormV3
            formId={formId}
            onSubmit={createSpaceGroupMutation}
            prefillData={prefillData}
          />
        </Modal.Body>
        <Modal.Footer
          secondaryAction={{
            label: t("cancel"),
            onClick: () => onOpenChange(false),
          }}
          primaryAction={{
            label: isSubmitting
              ? t("space_groups.form.create.submitting")
              : t("space_groups.form.create.submit"),
            type: "submit",
            form: formId,
            loading: isSubmitting,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
